import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'radarchart',
  label: 'Bar Chart',
  icon: 'DocumentTextIcon',
  description: 'A radar chart',
  properties: [
    {
      label: 'Text',
      name: 'text',
      editor: 'textbox',
      readonly: false,
      description: 'The text to display underneath the chart',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
